export default {
    accept:"Accept",
    average:"Average",
    cancel:"Cancel",
    categories:"Categories",
    categoryDist:"Category Distribution",
    clear:"Clear",
    clickOnDate:"Click on a date to assign a class",
    confirmDel:"Are you sure you want to delete this class?",
    contact:"Contact Us",
    contactDes: 'During normal business hours our maintenance team will return your calls and inquires within 24 hours. During weekends your calls will be handled the following business day.',
    copy:"Copy",
    copiedWeek:"Copied Week",
    delete:"Delete",
    devStatus:"My Devices",
    dislikes:"Dislikes",
    dislikesPeriod:"Dislikes This Period",
    likes:"Likes",
    likesPeriod:"Likes This Period",
    logoff:"Log Off",
    maintenance:"Scheduled maintenance on Wednesday 4.7.18 from 7:00 to 11:00.",
    modify:"Modify",
    mostLikedVideo:"Most Liked Video",
    mostViewedCategory:"Most Viewed Category",
    mostViewedVideo:"Most Viewed Video",
    paste:"Paste",
    save:"Save", 
    summary:"Summary",  
    views:"Views",
    viewsPeriod:"Views This Period",
    week:"Week",
    weekControl:"Week Control",
    welcome:"Welcome",
}


// WEBPACK FOOTER //
// ./src/lang/en/index.js